const tableTitleExpiredServices = {
  title: 'Servicios Vencidos',
  placeholder: 'Buscar',
};

export default tableTitleExpiredServices;
